import React from 'react';
import { CodeMappingTile } from "app/area/code-mappings/components/code-mapping-tile";
import { getModifiedItem } from "app/area/code-mappings/selectors";
import { ComplexValue } from 'app/types-shared';
import { CodeMappingItemProps } from 'app/area/code-mappings/components/types';

export const CodeMappingItem = ({
  data, index, displayCopyToAll, metadata, mappingsList, modifiedMappings, translation, codetableAccess, validation,
  codetableOptions, updatingExternalValue, modifyItem, copyToAll, loadMetadata, loadCodetableOptions,
  loadCodetablesAccess, loadCategoryOptions
}: CodeMappingItemProps) => {
  const previousText = index > 0 ? mappingsList[index - 1] : undefined;
  const modifiedItem = getModifiedItem(modifiedMappings, data);
  const code = modifiedItem ? modifiedItem.code : data?.code;
  const codeCategory = modifiedItem ? modifiedItem.codeCategory : data?.codeCategory;

  const onModifyItem = (modifiedCode?: ComplexValue<number>, modifiedCodeCategory?: ComplexValue<number>) => {
    modifyItem({
      id: data?.id,
      codetable: data?.codetable?.value ?? undefined,
      description: modifiedItem?.description || data?.description || undefined,
      code: modifiedCode ?? undefined,
      codeCategory: modifiedCodeCategory ?? undefined
    });
  };

  return <CodeMappingTile
    codeData={data}
    previousCodeData={previousText}
    description={modifiedItem?.description || data?.description || ''}
    code={code}
    codeCategory={codeCategory}
    codetableAccess={codetableAccess}
    edited={!!modifiedItem}
    displayCopyToAll={index === 0 && displayCopyToAll}
    codetableOptions={codetableOptions}
    metadata={metadata}
    modifiedMappings={modifiedMappings}
    updatingExternalValue={updatingExternalValue}
    translation={translation}
    validation={validation}
    modifyCode={onModifyItem}
    copyToAll={copyToAll}
    loadCodetableOptions={loadCodetableOptions}
    loadCategoryOptions={loadCategoryOptions}
    loadCodetablesAccess={loadCodetablesAccess}
    loadMetadata={loadMetadata}

  />;
};
